import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaPhone, FaShieldAlt, FaTools, FaUsers, FaMapMarkerAlt } from 'react-icons/fa';
import HizmetCard from '../components/HizmetCard';
import YorumCard from '../components/YorumCard';
import Lightbox from '../components/Lightbox';
import { getHizmetler, getYorumlar, getSiteBilgileri, getLightbox } from '../services/api';
import './AnaSayfa.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8000';

const AnaSayfa = () => {
  const [hizmetler, setHizmetler] = useState([]);
  const [yorumlar, setYorumlar] = useState([]);
  const [ayar, setAyar] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    getHizmetler()
      .then(res => setHizmetler(res.data.results || res.data))
      .catch(err => console.error(err));

    getYorumlar()
      .then(res => setYorumlar(res.data.results || res.data))
      .catch(err => console.error(err));

    getSiteBilgileri()
      .then(res => setAyar(res.data))
      .catch(err => console.error(err));

    getLightbox()
      .then(res => {
        if (res.data.aktif !== false) {
          setLightbox(res.data);
          setLightboxOpen(true);
        }
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="ana-sayfa">
      {lightboxOpen && lightbox && (
        <Lightbox
          baslik={lightbox.baslik}
          icerik={lightbox.icerik}
          onClose={() => setLightboxOpen(false)}
        />
      )}
      {/* Hero Section */}
      <section
        className={`hero hero-${ayar?.hero_yukseklik || 'medium'}`}
        style={ayar ? {
          '--hero-bg-type': ayar.hero_bg_type,
          '--hero-bg-color': ayar.hero_bg_color || '#2d2d2d',
          '--hero-bg-color-2': ayar.hero_bg_color_2 || '#1a1a1a',
          '--hero-overlay-opacity': ayar.hero_overlay_opacity ?? 0.5,
          ...(ayar.hero_bg_type === 'image' && ayar.hero_bg_image
            ? { backgroundImage: `url(${BACKEND_URL}${ayar.hero_bg_image})`, backgroundSize: 'cover', backgroundPosition: 'center' }
            : ayar.hero_bg_type === 'solid'
              ? { background: ayar.hero_bg_color || '#2d2d2d' }
              : { background: `linear-gradient(135deg, ${ayar.hero_bg_color || '#2d2d2d'} 0%, ${ayar.hero_bg_color_2 || '#1a1a1a'} 50%, #0f0f23 100%)` }
          ),
        } : {}}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>{ayar?.hero_baslik || 'Karpat Otomotiv'}</h1>
          <p className="hero-subtitle">{ayar?.hero_alt_baslik || 'Güvenilir Oto Servis Hizmetleri'}</p>
          <p className="hero-desc">
            {ayar?.hero_aciklama || 'Uzman kadromuz ve modern ekipmanlarımızla aracınıza en iyi bakımı sağlıyoruz.'}
          </p>
          <div className="hero-buttons">
            <Link to="/randevu" className="btn btn-primary">
              Randevu Al <FaArrowRight />
            </Link>
            <a href={`tel:${ayar?.telefon?.replace(/\s/g, '') || '05320000000'}`} className="btn btn-secondary">
              <FaPhone /> Hemen Ara
            </a>
            {ayar?.harita_url && (
              <a href={ayar.harita_url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                <FaMapMarkerAlt /> Yol Tarifi Al
              </a>
            )}
          </div>
        </div>
      </section>

      {/* Arvento Yetkili Servis */}
      {ayar?.arvento_aktif !== false && (
        <section className="arvento-section">
          <div className="container">
            <div className="arvento-wrapper">
              {ayar?.arvento_logo && (
                <div className="arvento-logo">
                  <img src={`${BACKEND_URL}${ayar.arvento_logo}`} alt="Arvento Mobile Systems" />
                </div>
              )}
              <div className="arvento-content">
                <h2>{ayar?.arvento_baslik || 'Arvento Yetkili Servis'}</h2>
                <p>{ayar?.arvento_aciklama || 'Karpat Otomotiv olarak Arvento Mobile Systems yetkili servis noktasıyız.'}</p>
                {ayar?.arvento_url && (
                  <a href={ayar.arvento_url} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                    Arvento Hakkında <FaArrowRight />
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Neden Biz Section */}
      <section className="neden-biz">
        <div className="container">
          <h2 className="section-title">Neden Karpat Otomotiv?</h2>
          <div className="neden-grid">
            <div className="neden-card">
              <FaShieldAlt className="neden-icon" />
              <h3>{ayar?.neden_1_baslik || 'Güvenilir Hizmet'}</h3>
              <p>{ayar?.neden_1_aciklama || 'Yıllara dayanan tecrübemizle güvenilir ve kaliteli hizmet sunuyoruz.'}</p>
            </div>
            <div className="neden-card">
              <FaTools className="neden-icon" />
              <h3>{ayar?.neden_2_baslik || 'Uzman Kadro'}</h3>
              <p>{ayar?.neden_2_aciklama || 'Alanında uzman teknisyenlerimizle tüm marka ve modele hizmet veriyoruz.'}</p>
            </div>
            <div className="neden-card">
              <FaUsers className="neden-icon" />
              <h3>{ayar?.neden_3_baslik || 'Müşteri Memnuniyeti'}</h3>
              <p>{ayar?.neden_3_aciklama || 'Binlerce mutlu müşteriyle güvenle çalışmaya devam ediyoruz.'}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Hizmetler Section */}
      <section className="hizmetler-section">
        <div className="container">
          <h2 className="section-title">Hizmetlerimiz</h2>
          <p className="section-subtitle">Aracınız için kapsamlı bakım ve onarım hizmetleri</p>
          <div className="hizmetler-grid">
            {hizmetler.slice(0, 6).map(hizmet => (
              <HizmetCard key={hizmet.id} hizmet={hizmet} />
            ))}
          </div>
          <div className="section-cta">
            <Link to="/hizmetler" className="btn btn-outline">
              Tüm Hizmetleri Gör <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* İstatistikler */}
      <section className="istatistikler">
        <div className="container">
          <div className="istatistik-grid">
            <div className="istatistik-item">
              <span className="istatistik-sayi">{ayar?.istatistik_1_sayi || '15+'}</span>
              <span className="istatistik-label">{ayar?.istatistik_1_etiket || 'Yıllık Deneyim'}</span>
            </div>
            <div className="istatistik-item">
              <span className="istatistik-sayi">{ayar?.istatistik_2_sayi || '5.000+'}</span>
              <span className="istatistik-label">{ayar?.istatistik_2_etiket || 'Mutlu Müşteri'}</span>
            </div>
            <div className="istatistik-item">
              <span className="istatistik-sayi">{ayar?.istatistik_3_sayi || '12.000+'}</span>
              <span className="istatistik-label">{ayar?.istatistik_3_etiket || 'Tamamlanan İş'}</span>
            </div>
            <div className="istatistik-item">
              <span className="istatistik-sayi">{ayar?.istatistik_4_sayi || '%100'}</span>
              <span className="istatistik-label">{ayar?.istatistik_4_etiket || 'Memnuniyet'}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Yorumlar */}
      <section className="yorumlar-section">
        <div className="container">
          <h2 className="section-title">Müşteri Yorumları</h2>
          <p className="section-subtitle">Müşterilerimiz bizim hakkımızda ne diyor?</p>
          <div className="yorumlar-grid">
            {yorumlar.slice(0, 4).map(yorum => (
              <YorumCard key={yorum.id} yorum={yorum} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>{ayar?.cta_baslik || 'Aracınız İçin Hemen Randevu Alın'}</h2>
          <p>{ayar?.cta_aciklama || 'Uzman ekibimiz aracınıza en iyi bakımı sağlamak için hazır.'}</p>
          <div className="cta-buttons">
            <Link to="/randevu" className="btn btn-primary">Randevu Al</Link>
            <a href={`tel:${ayar?.telefon?.replace(/\s/g, '') || '05320000000'}`} className="btn btn-secondary"><FaPhone /> {ayar?.telefon || '0532 000 00 00'}</a>
            {ayar?.harita_url && (
              <a href={ayar.harita_url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary"><FaMapMarkerAlt /> Yol Tarifi Al</a>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnaSayfa;
